import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import { createTV, type VariantProps } from 'tailwind-variants';

export type { VariantProps };

export const twMergeConfig = {
  extend: {
    theme: {
      spacing: [
        '3xs',
        '2xs',
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        '2xl',
        '3xl',
        '4xl',
        '5xl',
        '6xl',
        'md-banner',
        'full-banner',
        'full-banner-y',
        'gutter',
        'button',
        'input-y',
        'mobile-input-y',
      ],
    },
    classGroups: {
      'font-size': ['text-tiny'],
    },
  },
};

const twMerge = extendTailwindMerge(twMergeConfig);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// tv() with our custom classGroups so variant slots (e.g. text-tiny) survive
// tailwind-variants' own internal merge instead of being stripped before cn() runs.
export const tv = createTV({ twMergeConfig });

type SlugParam = string | string[] | undefined;

export function getSlugFromParam(param: SlugParam): string | undefined {
  if (typeof param === 'string') return param;

  return param?.[0];
}
